import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS, PROVIDER_GROUP } from './utils'
import store from '@/store'

export default [
  {
    path: '/',
    name: 'Sinister',
    component: Layout,
    meta: {
      title: 'Siniestros',
      showInSidebar: true,
      icon: 'mdi-car',
      ifCan: {
        view: 'Sinister/sinister'
      }
    },
    children: [
      {
        path: '/siniestros/listado',
        name: 'Sinister List',
        component: () => import('@/pages/Sinister/List/index.vue'),
        meta: {
          excludeGroup: [PROVIDER_GROUP, ...EXTRANET_GROUPS],
          title: 'Listado',
          showInSidebar: true,
          forceRefresh: true
        }
      },
      {
        path: '/siniestros/edicion/:id',
        name: 'Register Edition',
        props: true,
        component: () => import('@/pages/Sinister/Register/index.vue'),
        meta: {
          title: 'Registro',
          ifCan: {
            change: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/siniestros/registro',
        name: 'Register New',
        component: () => import('@/pages/Sinister/Register/index.vue'),
        meta: {
          showInSidebar: true,
          title: 'Registro',
          ifCan: {
            add: 'Sinister/sinister'
          },
          excludeGroup: ['CoDi', PROVIDER_GROUP]
        }
      },
      {
        path: '/siniestros/reasignacion',
        name: 'Reassigment',
        component: () => import('@/pages/Sinister/Reassignment/index.vue'),
        meta: {
          showInSidebar: true,
          title: 'Reasignación de siniestros',
          ifCan: {
            add: 'Sinister/sinister'
          },
          excludeGroup: ['CoDi', PROVIDER_GROUP]
        }
      },
      {
        path: '/siniestros/seguimientos_quejas',
        name: 'Follow Ups',
        component: () => import('@/pages/Sinister/FollowUps/index.vue'),
        meta: {
          showInSidebar: true,
          title: 'Seguimientos/Quejas',
          ifCan: {
            view: 'Sinister/followup'
          }
        }
      },
      {
        path: '/siniestros/:slug',
        name: 'File',
        props: true,
        component: () => import('@/pages/Sinister/File/index.vue'),
        meta: {
          showInSidebar: false,
          title: 'Ficha de siniestro'
        },
        beforeEnter: ({ params }, _, next) => {
          const isProvider = store.getters['account/userInGroup'](PROVIDER_GROUP)
          if (isProvider) {
            next({ name: 'File Provider', params })
          } else if (EXTRANET_GROUPS.some(g => store.getters['account/userInGroup'](g))) {
            next({ name: 'Extranet Sinister File', params })
          } else {
            next()
          }
        }
      },
      {
        path: '/siniestros_proveedor/:slug',
        name: 'File Provider',
        props: true,
        component: () => import('@/pages/Sinister/FileProvider/index.vue'),
        meta: {
          ifInGroup: [PROVIDER_GROUP, 'Admin'],
          showInSidebar: false

        }
      },
      {
        path: '/siniestros/vista_impresion/:sinister',
        name: 'Preview Grid',
        props: true,
        component: () => import('@/pages/Sinister/File/PreviewGrid/index.vue'),
        meta: {
          excludeGroup: [EXTRANET_GROUPS],
          showInSidebar: false
        }
      },
      {
        path: '/siniestros/archivo_afectado/:casualty',
        name: 'Affected File',
        props: true,
        component: () => import('@/pages/Sinister/File/PreviewGrid/KAffectedFile.vue'),
        meta: {
          excludeGroup: [EXTRANET_GROUPS],
          showInSidebar: false
        }
      }
    ]
  }
]
